export default function LinkedInIcon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="white" fill-opacity="0.87" />
      <path
        d="M12.6906 14.9981C13.9494 14.9981 14.9698 13.9778 14.9698 12.7192C14.9698 11.4606 13.9494 10.4403 12.6906 10.4403C11.4319 10.4403 10.4114 11.4606 10.4114 12.7192C10.4114 13.9778 11.4319 14.9981 12.6906 14.9981Z"
        fill="#333333"
      />
      <path
        d="M17.1219 16.7249V29.3683H21.0479V23.1159C21.0479 21.4661 21.3583 19.8683 23.4041 19.8683C25.4219 19.8683 25.4469 21.7546 25.4469 23.22V29.3693H29.375V22.4357C29.375 19.0299 28.6416 16.4125 24.6604 16.4125C22.7489 16.4125 21.4677 17.4613 20.9437 18.4539H20.8906V16.7249H17.1219ZM10.7239 16.7249H14.6562V29.3683H10.7239V16.7249Z"
        fill="#333333"
      />
    </svg>
  );
}
